import React, { useState, useEffect } from 'react'
import { Button, Input, Select, Table } from 'antd'
import 'aos/dist/aos.css'
import '../../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  DeleteAlloyMaster,
  DeletePressMaster,
  GetAlloyMaster,
  GetPressMaster,
  SaveAlloyMaster,
  SavePressMaster,
  UpdateAlloyMaster,
  UpdatePressMaster,
} from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { DiaMasterGet } from '../../../AllAPI/MasterAPI/DiesMasterApi'

const PressMaster = () => {
const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

  const [errors, setErrors] = useState({
    pressName: '',
    dieDia: '',
    description: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [pressId, setPressId] = useState('')
  const [pressName, setPressName] = useState('')
  const [dieDia, setDieDia] = useState([])
  const [description, setDescription] = useState('')

  const [allPress, setAllPress] = useState([])
   const [allDiaMeter, setAllDiaMeter] = useState([]);
  const [updateButton, setUpdateButton] = useState(false)
  const [saveButton, setSaveButton] = useState(true)

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allPress.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch Press Names
  let isPressFetched = false
  useEffect(() => {
    if (isPressFetched) return
    fetchPress()
    fetchDiaMeter()
    isPressFetched = true
  }, [])

  //=========GET Press DATA============

  let isError = false

  const fetchPress = async () => {
    try {
      const response = await axios.get(GetPressMaster, commonHeaders1)
      if (response.data !== null) {
        setAllPress(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Press:', error)
        toast.error('Failed to fetch Press data')
        isError = true
      }
    }
  }

  // const columns = [
  //   {
  //     title: 'Sr.No.',
  //     dataIndex: '',
  //     key: 'index',
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: 'Press',
  //     dataIndex: 'pressName',
  //     key: 'pressName',
  //   },
  //   {
  //     title: 'Die Diameter',
  //     dataIndex: 'diaMasterList',
  //     key: 'diaMasterList',
  //     render: (diaMasterList) => {
  //       if (!diaMasterList || diaMasterList.length === 0) {
  //         return '-';
  //       }
  //       const diaNumbers = diaMasterList.map(item => item.diaNumber).join(', ');
  //       return diaNumbers;
  //     },
  //   },
  //   {
  //     title: 'Description',
  //     dataIndex: 'description',
  //     key: 'description',
  //   },
  //   {
  //     title: 'Actions',
  //     key: 'actions',
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ]

  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Press',
    dataIndex: 'pressName',
    key: 'pressName',
    sorter: (a, b) => a.pressName?.localeCompare(b.pressName || '') || 0,
  },
  {
    title: 'Die Diameter',
    dataIndex: 'diaMasterList',
    key: 'diaMasterList',
    sorter: (a, b) => {
      const aDia = (a.diaMasterList || []).map(item => item.diaNumber).join(', ');
      const bDia = (b.diaMasterList || []).map(item => item.diaNumber).join(', ');
      return aDia.localeCompare(bDia);
    },
    render: (diaMasterList) => {
      if (!diaMasterList || diaMasterList.length === 0) {
        return '-';
      }
      const diaNumbers = diaMasterList.map(item => item.diaNumber).join(', ');
      return diaNumbers;
    },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    sorter: (a, b) => a.description?.localeCompare(b.description || '') || 0,
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
  ];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

   const fetchDiaMeter = async () => {
    
      try {
        const response = await axios.get(DiaMasterGet,commonHeaders1);
        if (response.data !== null) {
          setAllDiaMeter(response.data);
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching DiaMeter:", error);
          toast.error("Failed to fetch DiaMeter data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };

  //=========CANCEL Press DATA============
  const handleCancel = () => {
    setPressName('')
    // setDieDia('')
    setDieDia([]);
    setDescription('')
    setUpdateButton(false)
    setSaveButton(true)
    setErrors('')
  }

  //=========SAVE Press DATA============
  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!pressName.trim()) {
      isValid = false
      errorObj.pressName = 'Press Name is required *'
    }
    if (!dieDia) {
      isValid = false
      errorObj.dieDia = 'DieDia is required *'
    }
    if (!description.trim()) {
      isValid = false
      errorObj.description = 'Description is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const saveData = {
      pressName: pressName,
      dieDiameter: dieDia.join(','),
      description: description,
    }

    try {
      const response = await axios.post(
        SavePressMaster,
        saveData,
        commonHeaders,
      )

      if (response.data === 'CREATED') {
        toast.success('Press added successfully!')
        fetchPress()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Press already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT Press DATA============
  const handleEditDataButton = (item) => {
    setUpdateButton(true)
    setSaveButton(false)
    window.scrollTo(0, 0)

    setPressId(item.id)
    setPressName(item.pressName)
    
    setDieDia(item.dieDiameter.split(',').map(Number)); // 👈 Convert back to [1, 3, 4]

    setDescription(item.description)
  }

  //=========UPDATE Press DATA============
  const handleUpdate = async () => {
    if (!pressName) {
      toast.warn('Please fill all fields!')
      return
    }

    const updateData = {
      id: pressId,
      pressName: pressName,
      dieDiameter: dieDia.join(','),
      description: description,
    }

    try {
      const response = await axios.put(
        UpdatePressMaster,
        updateData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Press updated successfully!')
        fetchPress()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Press already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE Press DATA============
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Press "${item.pressName}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeletePressMaster}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        toast.success('Press deleted successfully!')
        fetchPress()
        handleCancel()
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Press')
    }
  }

  return (
    <>
      <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
              <div className="row p-0 m-0">
                <div className="col-12 col-lg-4"></div>
                <div className="col-12 col-lg-4">
                  <div className="row p-0 m-0">
                    <div className="col-12 py-1">
                      <label className="labels">Press Name</label>
                      <Input
                        maxLength="250"
                        value={pressName}
                        onChange={(e) => setPressName(e.target.value)}
                        placeholder="Enter Name"
                      />
                      {errors.pressName && (
                        <div className="errorField">{errors.pressName}</div>
                      )}
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Die Diameter</label>

                      <Select
                        mode="multiple" // 👈 Enables multi-select
                        value={dieDia || []}
                        onChange={setDieDia}
                        showSearch
                        className="w-100"
                        placeholder="Select"
                        optionFilterProp="children"
                      >
                        {allDiaMeter.map((diameter) => (
                          <Option key={diameter.id} value={diameter.id}>
                            {diameter.diaNumber}
                          </Option>
                        ))}
                      </Select>


                      {errors.dieDia && (
                        <div className="errorField">{errors.dieDia}</div>
                      )}
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Description</label>
                      <Input.TextArea
                        value={description}
                        maxLength="250"
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter Description"
                        style={{ width: '100%' }}
                      />
                      {errors.description && (
                        <div className="errorField">{errors.description}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4"></div>
              </div>

              <div className="col-12 text-center pt-3">
                <Button
                  type="submit"
                  className="CancelBtn mx-1"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                {saveButton && (
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                )}
                {updateButton && (
                  <Button
                    type="submit"
                    className="UpdateBtn mx-1"
                    onClick={handleUpdate}
                  >
                    Update
                  </Button>
                )}
              </div>

              <div
                className="col-12 p-0 mt-3"
                style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
              ></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PressMaster
